export default function (state = false, action) {
    switch (action.type) {
        case "CREATED_EXPERT":
            return action.payload
            break;
        default:
            return state;
    }
}